import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats from "components/Headers/HeaderStats.js";

// Views
import Inventory from "views/labincharge/Inventory.js";
import CreateInventory from "views/labincharge/CreateInventory.js";
import AssignInventory from "components/Assign Inventory/AssignInventory";
import AssignCreateInventory from "components/Assign Inventory/AssignCreateInventory";

const getToken = () => localStorage.getItem("token");
const isAuthenticated = () => {
    const token = getToken();
    if (!token) return false;
    try {
        const decoded = jwtDecode(token);
        const expired = decoded.exp * 1000 < Date.now();
        if (expired) {
            localStorage.clear();
            return false;
        }
        return true;
    } catch {
        return false;
    }
};

const getRole = () => {
    const token = getToken();
    if (!token) return null;
    try {
        return jwtDecode(token).role;
    } catch {
        return null;
    }
};

const ProtectedRoute = ({ children, allowedRoles }) => {
    const location = useLocation();
    const auth = isAuthenticated();
    const role = getRole();

    if (!auth) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/auth/login" replace />;
    }

    return (
        <>
            <Sidebar />
            <div className="relative md:ml-64 bg-dark-primary min-h-screen">
                <AdminNavbar />
                <HeaderStats />
                <div className="px-4 md:px-10 mx-auto w-full -m-24">{children}</div>
            </div>
        </>
    );
};

const LabIncharge = () => {
    return (
        <Routes>
            <Route
                path="/inventory"
                element={
                    <ProtectedRoute allowedRoles={["labincharge"]}>
                        <Inventory />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/createInventory"
                element={
                    <ProtectedRoute allowedRoles={["labincharge"]}>
                        <CreateInventory />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/assign-inventory"
                element={
                    <ProtectedRoute allowedRoles={["labincharge"]}>
                        <AssignInventory />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/assign-create-inventory"
                element={
                    <ProtectedRoute allowedRoles={["labincharge"]}>
                        <AssignCreateInventory />
                    </ProtectedRoute>
                }
            />
            <Route path="/" element={<Navigate to="/labincharge/inventory" />} />
            <Route path="*" element={<Navigate to="/labincharge/inventory" />} />
        </Routes>
    );
};

export default LabIncharge;
